(function(){
  'use strict';
  if(window.location.pathname.indexOf('/cart')!==0)return;
  function changeQuantity(control,delta){
    var input=control.querySelector('.ld-cart-quantity__input');
    if(!input||control.classList.contains('is-loading'))return;
    var current=Math.max(0,parseInt(input.value,10)||0);
    var next=Math.max(0,current+delta);
    if(next===current)return;
    control.classList.add('is-loading');
    control.querySelectorAll('button,input').forEach(function(el){el.disabled=true;});
    input.value=next;
    fetch('/cart/change.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:input.getAttribute('data-line-key'),quantity:next})
    }).then(function(response){if(!response.ok)throw new Error('Cart update failed');return response.json();})
      .then(function(){window.location.reload();})
      .catch(function(){input.value=current;control.classList.remove('is-loading');control.querySelectorAll('button,input').forEach(function(el){el.disabled=false;});});
  }
  document.addEventListener('click',function(event){
    var minus=event.target.closest&&event.target.closest('[data-ld-quantity-minus]');
    var plus=event.target.closest&&event.target.closest('[data-ld-quantity-plus]');
    if(!minus&&!plus)return;
    event.preventDefault();
    var control=(minus||plus).closest('[data-ld-cart-quantity]');
    if(control)changeQuantity(control,minus?-1:1);
  });
}());
